import {Dispatch, SetStateAction, useState} from 'react';


export function useProvider<T> (c: { new (...args: any[]): T }, ...args: any[]):  readonly [T, Dispatch<SetStateAction<T>>] {
  const [ provider, setProvider ] = useState<T>(new c(...args));

  return [ provider, setProvider ] as const;
}
